import { EventEmitter } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { createHoursRange } from '../workingHoursFormCreator';
import { defaultHours } from '../../../lead-generation/shared/domain/WorkingHours';
var WorkingHoursRangeComponent = /** @class */ (function () {
    function WorkingHoursRangeComponent(fb) {
        this.fb = fb;
        this.selectionChange = new EventEmitter();
        this.deleteClicked = new EventEmitter();
    }
    Object.defineProperty(WorkingHoursRangeComponent.prototype, "days", {
        get: function () {
            return this.daysForm.value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WorkingHoursRangeComponent.prototype, "daysForm", {
        get: function () {
            return this.range.get('days');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WorkingHoursRangeComponent.prototype, "hoursFormControls", {
        get: function () {
            return this.hoursForm.controls;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WorkingHoursRangeComponent.prototype, "hoursForm", {
        get: function () {
            return this.range.get('hours');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WorkingHoursRangeComponent.prototype, "canRemoveHoursRange", {
        get: function () {
            return this.hoursForm.length > 1;
        },
        enumerable: true,
        configurable: true
    });
    WorkingHoursRangeComponent.prototype.removeHoursRange = function (index) {
        this.hoursForm.removeAt(index);
    };
    WorkingHoursRangeComponent.prototype.addHoursRange = function () {
        this.hoursForm.push(createHoursRange(defaultHours, this.fb));
    };
    WorkingHoursRangeComponent.prototype.deleteRange = function () {
        if (this.deleteEnabled) {
            this.deleteClicked.emit();
        }
    };
    WorkingHoursRangeComponent.prototype.onSelectionChanged = function (day) {
        var userDeselectedDay = this.days.includes(day);
        if (userDeselectedDay) {
            var index = this.days.indexOf(day);
            this.daysForm.removeAt(index);
        }
        else {
            this.daysForm.push(new FormControl(day));
        }
        this.selectionChange.emit(day);
    };
    return WorkingHoursRangeComponent;
}());
export { WorkingHoursRangeComponent };
